import { http } from '~/lib/http'
import { ForgotPasswordForm, RegisterForm, ResetPasswordForm } from '~/schemas/auth'
import { LoginRes, RegisterRes } from '~/types/auth'
import { Res } from '~/types/common'

export type LoginReq = {
    username: string
    password: string
}

const authApi = {
    login: async (data: LoginReq) => {
        const res = await http.post<Res<LoginRes>>('/auth/login', data)
        return res
    },
    logout: async () => {
        const res = await http.post<Res<null>>('/auth/logout', null)
        return res
    },
    loginNext: (data: { token: string }) => {
        return http.post<Res<null>>('/api/auth/login', data, {
            baseUrl: ' '
        })
    },
    logoutNext: () => {
        return http.post<Res<null>>('/api/auth/logout', null, {
            baseUrl: ' '
        })
    },
    register: (data: RegisterForm) => {
        return http.post<Res<RegisterRes>>('/auth/register', data)
    },
    checkVerify: (t: string) => {
        return http.get<Res<null>>(`/auth/verify-account?t=${t}`)
    },
    resendVerify: (t: string) => {
        return http.get<Res<null>>(`/auth/resend-verify-email?t=${t}`)
    },
    verify: (t: string, code: string) => {
        return http.post<Res<null>>('/auth/verify-account', { t, code })
    },
    forgotPassword: (data: ForgotPasswordForm) => {
        return http.post<Res<null>>('/auth/forgot-password', data)
    },
    checkResetPassword: (t: string) => {
        return http.get<Res<null>>(`/auth/reset-password?t=${t}`)
    },
    resetPassword: (t: string, data: ResetPasswordForm) => {
        return http.post<Res<null>>(`/auth/reset-password`, {
            t,
            ...data
        })
    }
}

export default authApi
